import { NgModule } from '@angular/core';
import { CoBrowseComponent } from '~shared/svgs/co-browser/co-browse.component';

@NgModule({
  declarations: [CoBrowseComponent],
  exports: [
    CoBrowseComponent
  ]
})
export class CoBrowseModule { }
